import { B2bEnvironment } from './environment.interface';
import { environment as prodEnvironment } from './environment.prod';

// ============================================================
// RUNTIME CONFIG — Docker/Kubernetes
//
// Este archivo es el "environment" por defecto cuando Angular
// compila sin fileReplacements (imagen Docker genérica).
//
// Flujo:
//   1. docker-entrypoint.sh genera /assets/config/runtime-config.json
//      con las variables del ConfigMap de Kubernetes.
//   2. RuntimeConfigService carga ese JSON y llama setRuntimeConfig().
//   3. El Proxy intercepta cada acceso a `environment.*` y devuelve
//      el valor runtime si existe, o el fallback de environment.prod.ts.
//
// NOTA sobre globalThis:
//   esbuild convierte módulos importados en lazy initializers.
//   Una variable `let _config = null` al inicio del módulo se
//   resetea a null cuando el lazy initializer se ejecuta, DESPUÉS
//   de que setRuntimeConfig() ya la había asignado.
//   globalThis no pertenece al módulo y no se ve afectado.
// ============================================================

const _RUNTIME_KEY = '__gemmaB2bRuntimeConfig__';

export function setRuntimeConfig(config: B2bEnvironment): void {
  (globalThis as any)[_RUNTIME_KEY] = config;
  console.log('🔧 Runtime config actualizada:', config.CLIENTE);
}

export function getRuntimeConfig(): B2bEnvironment | null {
  return (globalThis as any)[_RUNTIME_KEY] ?? null;
}

export const environment: B2bEnvironment = new Proxy(prodEnvironment, {
  get(target: B2bEnvironment, prop: keyof B2bEnvironment): any {
    const runtime = getRuntimeConfig();
    if (runtime !== null && prop in runtime && runtime[prop] !== undefined && runtime[prop] !== null) {
      return runtime[prop];
    }
    return target[prop];
  }
});
